import { render, staticRenderFns } from "./today-onfleet-driver-task-grid.vue?vue&type=template&id=8d2dd5de"
import script from "./today-onfleet-driver-task-grid.vue?vue&type=script&lang=js"
export * from "./today-onfleet-driver-task-grid.vue?vue&type=script&lang=js"
import style0 from "./today-onfleet-driver-task-grid.vue?vue&type=style&index=0&id=8d2dd5de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports